var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor-v2__page-set-tab flex h40 c-666 relative"},[_vm._l((_vm.tabs),function(item,i){return _c('div',{key:i,staticClass:"flex-center width-50 height-100",class:{
      active: i === _vm.value
    },on:{"click":function($event){return _vm.$emit('input', i)}}},[_c('span',[_vm._v(_vm._s(item))])])}),_c('div',{staticClass:"editor-v2__page-tab-line",style:({
      left: _vm.value === 0 ? 'calc(25% - 25px)' : 'calc(75% - 25px)'
    })})],2)}
var staticRenderFns = []

export { render, staticRenderFns }